<template>
  <el-form
    :id="markId"
    :ref="refForm"
    :model="model"
    :class="formClass"
    :label-width="labelWidth"
    :rules="rules"
    :inline="inline"
    :size="size"
    :label-position="labelPosition"
  >
    <slot />
  </el-form>
</template>

<script>
import { Form } from 'element-ui'
export default {
  name: 'Form',
  components: {
    ElForm: Form
  },
  provide() {
    return {
      cndForm: this,
      cubeForm: this
    }
  },
  props: {
    refForm: {
      type: String,
      default: ''
    },
    // 表单数据对象
    model: {
      type: Object,
      default: () => {}
    },
    // 表单验证规则
    rules: {
      type: Object,
      default: () => {}
    },
    labelWidth: {
      type: String,
      default: '100px'
    },
    size: {
      type: String,
      default: 'small'
    },
    inline: {
      type: Boolean,
      default: false
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    disabled: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      markId: ''
    }
  },
  computed: {
    // 表单类名
    formClass() {
      return `el-form-w${this.labelWidth.substr(0, this.labelWidth.length - 2)}`
    }
  },
  watch: {
    disabled(nv, ov) {
      // console.log('nv--', nv)
      this.setDisabledItem(false)
    }
  },
  created() {
    // 设置独有id
    this.markId = 'cubeForm' + (new Date().getTime()) + Math.ceil(Math.random() * 10000)
    // this.markId = 'cndForm' + (new Date().getTime()) + Math.ceil(Math.random() * 10000)
  },
  mounted() {
    this.setDisabledItem(true)
  },
  methods: {
    // 设置禁用表单
    setDisabledItem(flagInit) {
      const curForm = document.getElementById(this.markId)
      const inputList = curForm.getElementsByClassName('el-input__inner')
      // console.log('父设置--', curForm)
      // console.log('inputList--', inputList)
      if (!flagInit) this.resetDisabled(inputList)
      // 按顺序禁用
      this.disabled.forEach(item => {
        if (!isNaN(Number(item))) {
          inputList[Number(item) - 1].parentNode.classList.add('is-disabled')
          inputList[Number(item) - 1].setAttribute('disabled', true)
        }
      })
    },
    // 重置【数字顺序】禁用项
    resetDisabled(domList) {
      // console.log('父重置')
      domList.forEach(item => {
        item.parentNode.classList.remove('is-disabled')
        item.removeAttribute('disabled')
      })
    }
  }
}

</script>
